var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.82,18.18A45,45,0,0,0,18.18,81.82,45,45,0,0,0,81.82,18.18ZM50,9.06A40.77,40.77,0,0,1,77.19,19.43L19.43,77.19A40.91,40.91,0,0,1,50,9.06Zm0,81.88a40.77,40.77,0,0,1-27.34-10.5L80.44,22.66A40.91,40.91,0,0,1,50,90.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.55,49.75a1.28,1.28,0,1,0-1.27-1.28A1.28,1.28,0,0,0,61.55,49.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.66,63.51a2.9,2.9,0,0,0,2.9-2.9,2.74,2.74,0,0,0-.15-.87l-3.62,3.62A2.84,2.84,0,0,0,42.66,63.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.93,47.19a1.28,1.28,0,1,0,1.28,1.28A1.28,1.28,0,0,0,41.93,47.19Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.34,
    cy: 60.61,
    r: 2.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,47.18c2.09-.35,6.27-1.58,11.74-5.85,0,0-3.85-6.18-13-7.2L45.41,59.74a2.74,2.74,0,0,1,.15.87,2.9,2.9,0,0,1-2.9,2.9,2.84,2.84,0,0,1-.87-.15l-5,5a28.42,28.42,0,0,0,15,3.89c11.43,0,20.7-5.61,20.7-12.53a8.25,8.25,0,0,0-1.21-4.23,16.79,16.79,0,0,0,1.21-6.24A18,18,0,0,0,72.3,47.18Zm-10.75,0a1.28,1.28,0,1,1-1.27,1.28A1.28,1.28,0,0,1,61.55,47.19Zm-.21,16.32a2.9,2.9,0,1,1,2.89-2.9A2.9,2.9,0,0,1,61.34,63.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.64,30.74a22.5,22.5,0,0,0-12.2,3.52C25.57,32.31,20,41.33,20,41.33c4.91,3.83,8.78,5.22,11,5.71a16.63,16.63,0,0,0,1.14,8.65A8.15,8.15,0,0,0,31,59.74a7.79,7.79,0,0,0,.52,2.74L61.21,32.82A22.69,22.69,0,0,0,51.64,30.74Zm-9.71,19a1.28,1.28,0,1,1,1.28-1.28A1.28,1.28,0,0,1,41.93,49.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPork);
export default __webpack_public_path__ + "static/media/no-pork.f5c9b27642251f032821f865b7826a58.svg";
export { ForwardRef as ReactComponent };